import React from 'react'
import { Box, FormControl, Grid, InputLabel, MenuItem, Select, Typography } from '@mui/material'
import { type FormikContextType, useFormikContext } from 'formik'
import PortfolioSettlementProjectStatusChip from '../../../components/chips/PortfolioSettlementProjectStatusChip'
import { ProjectStatusChip } from '../../../components/chips/ProjectStatusChip'
import FormikTextField from '../../../components/ui-widgets/FormikTextField'
import {
  type PortfolioSettlementProjectDto
} from '../../../../api-schema-types/asset-holdings/AdminPortfolioSettlementDomainDtos'
import { type EditSettlementProjectFormProps } from './EditSettlementProjectForm'
import COATemplateVersionChip from '../../../components/chips/COATemplateVersionChip'

const ViewSettlementProjectDetail: React.FC<EditSettlementProjectFormProps> = ({ settlementProject }: EditSettlementProjectFormProps) => {
  const formikProps: FormikContextType<PortfolioSettlementProjectDto> = useFormikContext()

  const isEnergeaAmountEnabled = (): boolean => {
    if (settlementProject !== null) {
      return (settlementProject.energeaCells === 0)
    }
    return true
  }

  return (
    <>
      <Box sx={{ pb: 4 }}>
        {/* <h3>Portfolio Settlement Project details</h3> */}

        <Grid container spacing={4} >

          {/* ==================================================================================================== */}

          <Grid item md={7}>
            <FormikTextField formikProps={formikProps} fieldName={'projectDisplayName'} label={'Project'} type={'text'} locked={true}/>
          </Grid>

          <Grid item md={5} justifyContent={'space-evenly'} display={'flex'} flexDirection={'row'}>
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant={'body1'}>Project Status</Typography>
              <ProjectStatusChip projectStatus={settlementProject.projectStatus} />
            </Box>
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant={'body1'}>Settlement Status</Typography>
              <PortfolioSettlementProjectStatusChip status={settlementProject.status} />
            </Box>

            <Box sx={{ textAlign: 'center' }}>
              <Typography variant={'body1'}>COA Version</Typography>
              <COATemplateVersionChip version={settlementProject.coaTemplateVersion}/>
            </Box>
          </Grid>

          <Grid item md={1}>
            <FormikTextField formikProps={formikProps} fieldName={'saleValueCurrencyCode'} label={'Currency Code'} type={'text'} locked={true}/>
          </Grid>

          <Grid item md={2}>
            <FormikTextField formikProps={formikProps} fieldName={'saleValue'} label={'Sale Value'} type={'number'} locked={false}/>
          </Grid>

          <Grid item md={2}>
            <FormikTextField formikProps={formikProps} fieldName={'refundableAmount'} label={'Refundable Amount'} type={'number'} locked={true}/>
          </Grid>

          <Grid item md={2}>
            <FormikTextField formikProps={formikProps} fieldName={'energeaAmount'} label={'Energea Amount'} type={'number'} locked={isEnergeaAmountEnabled()}/>
          </Grid>

          <Grid item md={5}>
            <FormControl sx={{ width: '100%' }}>
              <InputLabel>Sale Category</InputLabel>
              <Select
                {...formikProps.getFieldProps('category.id')}
                label={'Sale Category'}
                // disabled={isFieldLocked()}
                // error={formikErrors.fieldInError('cellOwnerAgreements.templateVersionId')}
              >
                {
                  settlementProject.lookups.saleCategories.map((c) =>
                    <MenuItem key={c.id} value={c.id}>{c.code}</MenuItem>
                  )
                }
              </Select>
            </FormControl>
            {/* <FormHelperText>{formikErrors.getError('cellOwnerAgreements.templateVersionId')}</FormHelperText> */}
          </Grid>

          {/* ==================================================================================================== */}

          <Grid item md={12}>
            <FormikTextField formikProps={formikProps} fieldName={'saleValueJustification'} label={'Sale Value Justification'} type={'text'} locked={false}/>
          </Grid>

          {/* ==================================================================================================== */}

          <Grid item md={2}>
            <FormikTextField formikProps={formikProps} fieldName={'numberCells'} label={'# Cells'} type={'text'} locked={true}/>
          </Grid>

          <Grid item md={2}>
            <FormikTextField formikProps={formikProps} fieldName={'energeaCells'} label={'# Energea Cells'} type={'text'} locked={true}/>
          </Grid>

           <Grid item md={2}>
            <FormikTextField formikProps={formikProps} fieldName={'nonEnergeaCells'} label={'# Non Energea Cells'} type={'text'} locked={true}/>
           </Grid>

          <Grid item md={2}>
            <FormikTextField formikProps={formikProps} fieldName={'calculatedSaleValuePerCell'} label={'Value Per Cell'} type={'text'} locked={true}/>
          </Grid>

          <Grid item md={2}>
            <FormikTextField formikProps={formikProps} fieldName={'calculatedRefundPerCell'} label={'Refund Per Cell'} type={'text'} locked={true}/>
          </Grid>

          <Grid item md={2}></Grid>

          {/* ==================================================================================================== */}

          <Grid item md={2}>
            <FormikTextField formikProps={formikProps} fieldName={'numberCOAs'} label={'# COAs'} type={'text'} locked={true}/>
          </Grid>

          <Grid item md={2}>
            <FormikTextField formikProps={formikProps} fieldName={'countCellOwnerAgreementPdfs'} label={'# COA PDFs'} type={'text'} locked={true}/>
          </Grid>

          <Grid item md={2}>
            <FormikTextField formikProps={formikProps} fieldName={'countCellOwners'} label={'# Cell Owners'} type={'text'} locked={true}/>
          </Grid>

          {/* ==================================================================================================== */}

        </Grid>

      </Box>
    </>
  )
}

export default ViewSettlementProjectDetail
